import { render, staticRenderFns } from "./FormButtons.vue?vue&type=template&id=ffbb1b5a&scoped=true"
import script from "./FormButtons.vue?vue&type=script&lang=js"
export * from "./FormButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbb1b5a",
  null
  
)

export default component.exports